import React from 'react'
import { motion } from "framer-motion";
import perIcon from '../assets/personalloan.png'
import instIcon from '../assets/instanceloan.png'
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link } from 'react-router-dom';
import emrIcon from '../assets/emeloan.png'

export default function ServiceList() {
    const container = {
        hidden: {},
        visible: {
            transition: {
                staggerChildren: 0.18,
                delayChildren: 0.2,
            },
        },
    };

    const fadeUp = {
        hidden: {
            opacity: 0,
            y: 30,
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut",
            },
        },
    };
    const cardHover = {
        y: -6,
        boxShadow: "0px 20px 40px rgba(0,255,255,0.08)",
        transition: { duration: 0.3 },
    };
    const services = [
        {
            icon: instIcon,
            link: '/services/instant-loan',
            title: "Instant Loan",
            desc: "Suitable for smaller short-term funding requirements where quicker access to funds and shorter repayment timelines are preferred.",
        },
        
        {
            icon: emrIcon,
            link: '/services/emergency-loan',
            title: "Emergency Loan",
            desc: "Designed for urgent financial situations that may require immediate attention, including unplanned personal or family-related expenses.",
        },
        {
            icon: perIcon,
            link: '/services/personal-loan',
            title: "Personal Loan",
            desc: "Ideal for larger planned financial requirements with structured repayment options based on eligibility and profile evaluation.",
        },
    ];
    return (
        <section className="py-16 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4">

                {/* Heading */}
                <div className='max-w-4xl mx-auto text-center'>
                    <h2 className="text-3xl font-bold text-center"> 
                         Services for <span className='ms-text-secondary'>Salaried Professionals</span>
                    </h2>
                    <p className='py-2  text-gray-700 text-sm sm:text-base leading-8 pb-10'>Explore loan solutions designed to support different financial requirements, repayment preferences, and borrowing needs through a digitally managed borrowing experience.</p>
                </div>


                {/* Animated Container */}
                <motion.div
                    variants={container}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    className="grid grid-cols-1 md:grid-cols-3 gap-5"
                >
                    {services.map((service, index) => (
                        <motion.div
                            key={index}
                            variants={fadeUp}
                            whileHover={cardHover}
                            className="p-6 bg-white rounded-2xl shadow-md cursor-pointer " style={{ borderBottom: '5px solid #FF7B0E' }}
                        >
                            <img src={service.icon} alt='one' width={35} height={35} />
                            <h3 className="text-xl font-semibold mb-3 pt-5">
                                {service.title}
                            </h3>
                            <p className="text-gray-600 text-base pb-6">
                                {service.desc}
                            </p>
                            <Link to={service.link} className='hover:text-orange-500 font-medium' >Learn more <ChevronRightIcon /> </Link>
                        </motion.div>
                    ))}
                </motion.div>

            </div>
        </section>
    )
}
